module.exports = __webpack_public_path__ + "static/media/SEN manager.b1edbfd4.svg";